import { ConsentsOption, ConsentWithLabel } from "../common/GeneralClasses";
export class ConsentsLabelMapper {
  get(entries: ConsentWithLabel[]): ConsentsOption[] {
    return entries.map(
      (entry) => new ConsentsOption(entry.consent.code, entry.consent.channel, entry.label.value)
    );
  }
}
